/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onCreateFacerevealUser = /* GraphQL */ `subscription OnCreateFacerevealUser(
  $filter: ModelSubscriptionFacerevealUserFilterInput
  $owner: String
) {
  onCreateFacerevealUser(filter: $filter, owner: $owner) {
    id
    tokens
    jobs
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFacerevealUserSubscriptionVariables,
  APITypes.OnCreateFacerevealUserSubscription
>;
export const onUpdateFacerevealUser = /* GraphQL */ `subscription OnUpdateFacerevealUser(
  $filter: ModelSubscriptionFacerevealUserFilterInput
  $owner: String
) {
  onUpdateFacerevealUser(filter: $filter, owner: $owner) {
    id
    tokens
    jobs
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFacerevealUserSubscriptionVariables,
  APITypes.OnUpdateFacerevealUserSubscription
>;
export const onDeleteFacerevealUser = /* GraphQL */ `subscription OnDeleteFacerevealUser(
  $filter: ModelSubscriptionFacerevealUserFilterInput
  $owner: String
) {
  onDeleteFacerevealUser(filter: $filter, owner: $owner) {
    id
    tokens
    jobs
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFacerevealUserSubscriptionVariables,
  APITypes.OnDeleteFacerevealUserSubscription
>;
export const onCreateFacerevealJob = /* GraphQL */ `subscription OnCreateFacerevealJob(
  $filter: ModelSubscriptionFacerevealJobFilterInput
) {
  onCreateFacerevealJob(filter: $filter) {
    id
    result
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnCreateFacerevealJobSubscriptionVariables,
  APITypes.OnCreateFacerevealJobSubscription
>;
export const onUpdateFacerevealJob = /* GraphQL */ `subscription OnUpdateFacerevealJob(
  $filter: ModelSubscriptionFacerevealJobFilterInput
) {
  onUpdateFacerevealJob(filter: $filter) {
    id
    result
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUpdateFacerevealJobSubscriptionVariables,
  APITypes.OnUpdateFacerevealJobSubscription
>;
export const onDeleteFacerevealJob = /* GraphQL */ `subscription OnDeleteFacerevealJob(
  $filter: ModelSubscriptionFacerevealJobFilterInput
) {
  onDeleteFacerevealJob(filter: $filter) {
    id
    result
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnDeleteFacerevealJobSubscriptionVariables,
  APITypes.OnDeleteFacerevealJobSubscription
>;
